module.exports = __webpack_public_path__ + "static/media/fly0163.a4bd7364.webp";